import React, { useEffect, useState } from "react";
import Navbar from "../../components/Header";
import axios from "axios";
import Content from "../../components/HolidayRealEstate/Content";
import Footer from "../../components/Footer";
import HeroSection from "../../components/HolidayRealEstate/HeroSection";

function HolidayRealEstate() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/properties?type=HolidayHome`);
        const approved = res.data.filter(property => property.status === "approved");
        setData(approved);
        setFilterData(approved);
      } catch (err) {
        console.error("Error fetching holiday properties:", err);
        setData([]);
        setFilterData([]);
      }
    }

    getData();
  }, []);

  function handleFilter(searchResult) {
    let filtered = [...data];

    if (searchResult.city && searchResult.city !== "Dubai") {
      filtered = filtered.filter(property =>
        property.location.includes(searchResult.city)
      );
    }

    if (searchResult.propertyType !== "Any") {
      filtered = filtered.filter(
        property => property.propertyType === searchResult.propertyType
      );
    }

    if (searchResult.price !== "Any") {
      filtered = filtered.filter(
        property => parseInt(property.price) > parseInt(searchResult.price)
      );
    }

    if (searchResult.complete !== "Any") {
      filtered = filtered.filter(
        property => property.propertyStatus === searchResult.complete
      );
    }

    setFilterData(filtered);
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />
      <Content data={filterData} />
      <Footer />
    </div>
  );
}

export default HolidayRealEstate;
